import { render, staticRenderFns } from "./MainWIPProduction.vue?vue&type=template&id=576d5ea9&"
import script from "./MainWIPProduction.vue?vue&type=script&lang=js&"
export * from "./MainWIPProduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QList,QItem,QItemSection,QItemLabel,Ripple} from 'quasar'
component.options.components = Object.assign({QHeader,QToolbar,QBtn,QTooltip,QToolbarTitle,QCard,QImg,QList,QItem,QItemSection,QItemLabel}, component.options.components || {})
component.options.directives = Object.assign({Ripple}, component.options.directives || {})
